export default {
    init() {
        // JavaScript to be fired on all pages

        // Scroll Menu
        function scrollLogo() {
            $(window).on('scroll', () => {
                var windowScrollTop = $(window).scrollTop();
                if (windowScrollTop >= 500) {
                    $("#logoHeader").addClass("logoUp");
                    $("#logoHeader").removeClass("logoDown");
                    $("#logoHeaderFixed").addClass("logoDown");
                    $("#logoHeaderFixed").removeClass("logoUp");
                    $("#header").addClass("posDown");
                    $("#header").removeClass("posUp");
                } else if (windowScrollTop <= 200 && $("#logoHeader").hasClass("logoUp") && $("#header").hasClass("posDown")) {
                    $("#logoHeader").addClass("logoDown");
                    $("#logoHeader").removeClass("logoUp");
                    $("#logoHeaderFixed").addClass("logoUp");
                    $("#logoHeaderFixed").removeClass("logoDown");
                    $("#header").addClass("posUp");
                    $("#header").removeClass("posDown");
                }
            });
        }
        scrollLogo();

        // ScrollTo Menu
        $('.js-scrollTo a, .js-scrollTo').on('click', function () { // Au clic sur un élément
            var target = $(this).attr('href'); // Page cible
            var speed = 750; // Durée de l'animation (en ms)
            $('html, body').animate({ scrollTop: $(target).offset().top - 100 }, speed); // Go
            return false;
        });


        // Menu Mobile
        function showMenuMobile() {
            var documentWidth = $(window).innerWidth();
            if (documentWidth <= 991) {
                $('#blockMenu').addClass('navbar-collapse').addClass('collapse');
            } else {
                $('#blockMenu').removeClass('navbar-collapse').removeClass('collapse');
            }
        }
        showMenuMobile();
        $(window).resize(function () {
            showMenuMobile();
        });

        //Slick
        $('#slickRef').owlCarousel({
            loop:true,
            nav:true,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 2
                },
                1200: {
                    items: 3
                }
            }
        });

        //Masonry        
        $("img.lazy").lazyload({
            effect: 'fadeIn',
            effectspeed: 1000,
            threshold: 200
        });
        
        $('img.lazy').load(function() {
            masonry_update();
        });

        function slickAvAp_update() {     
            $('#slickAvAp').slick({
                lazyLoad: 'ondemand',
                dots: true,
            });
        }

        slickAvAp_update();
        
        function masonry_update() {     
            var $container = $('#listPhotoGallery');
            $container.imagesLoaded(function(){
                $container.masonry({
                    itemSelector: '.itemPhoto',
                    transitionDuration: '0.8s',
                    effect: 'fadeIn',
                    isFitWidth: true
                });
            });
         } 

        $("#selectReal a").on('click', 'a.ajax', function () {
            var idType = $(this).attr('id');
            $("#hiddenType").val(idType);
        });


        var tel = $("#blocHiddenTel p").html();
        var telTrim = tel.replace(/\s/g, '');
        $("#header #telContentHeader").html("Tél. : " + tel);
        $("#header #linkTelHeader").attr("href", "tel:" + telTrim);
        $("#templateContact #linkTelContact").html(tel);
        $("#templateContact #linkTelContact").attr("href", "tel:" + telTrim);


    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js